import React, { FC } from 'react';
import { Container, Form } from 'react-bootstrap';
import styles from './ReportingDetailsVerificationStatusForm.module.css';
import { Button, RadioButton, ValidationForm } from '../../atoms';
import { VerificationStatusResponseDto } from '../../../store/landscapeAPI/verificationStatus/dto/response/verification-status-response.dto';
import { ImageUploader } from '../../molecules';
import { ImageMeta } from '../../../store/mediaAPI/media/dto/request/media-save-request';

interface ReportingDetailsVerificationStatusFormProps {
  data: VerificationStatusResponseDto;
  handleVerificationStatus: (indicator: VerificationStatusResponseDto) => void;
  handleOnChange: (indicator: VerificationStatusResponseDto) => void;
  handleImageOnChange: (imageMeta: ImageMeta) => void;
}

const ReportingDetailsVerificationStatusForm: FC<
  ReportingDetailsVerificationStatusFormProps
> = ({
  data,
  handleVerificationStatus,
  handleOnChange,
  handleImageOnChange,
}) => {
  return (
    <Container className={styles.form}>
      <ValidationForm onSubmitCallback={() => handleVerificationStatus(data)}>
        <Form.Group className="mb-3">
          <Form.Label>Name</Form.Label>
          <Form.Control
            required
            type="text"
            value={data.name}
            onChange={(e) =>
              handleOnChange({
                ...data,
                name: e.target.value,
              })
            }
          />
          <Form.Control.Feedback type="invalid">
            Please provide a valid name
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Description</Form.Label>
          <Form.Control
            type="text"
            value={data.description ?? ''}
            onChange={(e) =>
              handleOnChange({
                ...data,
                description: e.target.value,
              })
            }
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Logo</Form.Label>
          <br />
          <ImageUploader
            setImage={(e) => {
              handleOnChange({ ...data, logoUrl: e });
            }}
            imageSrc={data.logoUrl ?? undefined}
            id={data.id}
            setImageMeta={(imageMeta) => handleImageOnChange(imageMeta)}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Is Published</Form.Label>
          <br />
          <RadioButton
            defaultChecked={data.published}
            onChange={(checked) =>
              handleOnChange({
                ...data,
                published: checked,
              })
            }
          />
        </Form.Group>

        <Button variant={'dark'} type={'submit'}>
          Save
        </Button>
      </ValidationForm>
    </Container>
  );
};

export default ReportingDetailsVerificationStatusForm;
